'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactisDatagrid = require('reactis-datagrid');

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _utilsUtils = require('../utils/utils');

var _components = {
	_$Datagrid: {
		displayName: 'Datagrid'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Datagrid = (function (_React$Component) {
	_inherits(Datagrid, _React$Component);

	function Datagrid() {
		_classCallCheck(this, _Datagrid);

		_React$Component.apply(this, arguments);
	}

	Datagrid.prototype.refresh = function refresh() {
		this.refs.datagrid.getWrappedInstance().refresh();
	};

	Datagrid.prototype.getLines = function getLines() {
		var lines = Math.round((_utilsUtils.getWindowSize().height - 260) / 30);
		if (lines < 16) {
			lines = 16;
		}
		if (this.props.limit) {
			lines = this.props.limit;
		}
		return lines;
	};

	Datagrid.prototype.render = function render() {
		var _this = this;

		var loading = this.props.state && this.props.state.get('pending') ? 'rotate' : '';

		var filters = this.props.filters ? this.props.filters.map(function (name) {
			return _react2['default'].createElement(_reactisDatagrid.FilterField, { key: name, filter: _this.props.filter, field: name, style: { marginLeft: 10, float: 'right' } });
		}).reverse() : false;

		var getRowClassName = function getRowClassName(row) {
			if (typeof row.active == 'undefined') {
				return;
			}
			return !row.active ? 'archive' : null;
		};

		return _react2['default'].createElement(
			'div',
			null,
			!this.props.disableButtons && _react2['default'].createElement(
				'div',
				{ className: 'dgtoolbar vp-tablet' },
				filters,
				_react2['default'].createElement(
					_reactBootstrap.Button,
					{ onClick: function () {
							return _this.refresh();
						}, title: this.props.alt, style: { float: 'right', marginRight: 0 } },
					_react2['default'].createElement('i', { className: 'fa fa-refresh ' + loading, style: { fontSize: 15 } })
				),
				this.props.buttons,
				_react2['default'].createElement('div', { className: 'clearfix' })
			),
			_react2['default'].createElement(_reactisDatagrid.RxDatagrid, _extends({ ref: 'datagrid',
				getRowClassName: getRowClassName
			}, this.props, {
				compact: _utilsUtils.getWindowSize().width < 700,
				limit: this.getLines() }))
		);
	};

	_createClass(Datagrid, null, [{
		key: 'defaultProps',
		value: {
			alt: 'Obnovit',
			disableButtons: false
		},
		enumerable: true
	}]);

	var _Datagrid = Datagrid;
	Datagrid = _wrapComponent('_$Datagrid')(Datagrid) || Datagrid;
	Datagrid = _reactRedux.connect(function (state, ownProps) {
		return {
			state: state.datagrids.get(ownProps.id)
		};
	}, null, null, { withRef: true })(Datagrid) || Datagrid;
	return Datagrid;
})(_react2['default'].Component);

exports['default'] = Datagrid;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Datagrid.js
 ** module id = 87
 ** module chunks = 2
 **/